import {
  createTheme,
  MantineThemeOverride,
  Container,
  rem,
} from "@mantine/core"
import cx from "classnames"
import styles from "./wmTheme.mantine.module.scss"

const CONTAINER_SIZES: Record<string, string> = {
  xs: rem(444),
  sm: rem(576),
  md: rem(768),
  lg: rem(992),
  xl: rem(1200),
}

const wmTheme: MantineThemeOverride = createTheme({
  components: {
    Container: Container.extend({
      vars: (_, { size, fluid }) => ({
        root: {
          "--container-size": fluid
            ? "100%"
            : size !== undefined && size in CONTAINER_SIZES
            ? CONTAINER_SIZES[size]
            : rem(size),
        },
      }),
      classNames: (_, { size }) => ({
        root: cx({ [styles.responsiveContainer]: size === "responsive" }),
      }),
    }),
  },
  breakpoints: {
    xs: "0em",
    sm: "36em",
    md: "48em",
    lg: "62em",
    xl: "75em",
  },
  fontFamily: [`Maax-Regular`, `Arial Narrow`, `Arial`, `sans-serif`].join(`,`),
  fontFamilyMonospace: [
    "Maax-Mono",
    "SFMono-Regular",
    "SF Mono",
    "Consolas",
    "Liberation Mono",
    "Menlo",
    "monospace",
  ].join(","),
})

export default wmTheme
